/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Nav_BookInputs */

const en_landing_nav_book = /** @type {(inputs: Landing_Nav_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Book a session`)
};

const pl_landing_nav_book = /** @type {(inputs: Landing_Nav_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarezerwuj zajęcia`)
};

/**
* | output |
* | --- |
* | "Book a session" |
*
* @param {Landing_Nav_BookInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const landing_nav_book = /** @type {((inputs?: Landing_Nav_BookInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Nav_BookInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_landing_nav_book(inputs)
	return en_landing_nav_book(inputs)
});